<template>
  <div class="wrapper">
    <side-bar :title="'Makita'">
      <template slot="links">
        <sidebar-link to="/panel/distribuidores" name="distribuidores" icon="ti-view-list-alt" />
        <li @click="exportarExcel()" class="customLink nav-item router-link-exact-active">
          <a class="nav-link">
            <slot>
              <i class="ti-view-list-alt"></i>
              <p>Exportar Excel</p>
            </slot>
          </a>
        </li>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
export default {
  components: {
    TopNavbar,
    DashboardContent
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async exportarExcel() {
      const response = await this.axios.get("/exportarExcel.php");

      if (response.status === 200) {
        let a = document.createElement("a");
        a.href = response.data.file;
        document.body.appendChild(a);
        a.download = "Garantias.xlsx";
        a.click();
        a.remove();
        this.$store.dispatch("ui/makeToast", {
          title: "Excel generado correctamente."
        });
      } else {
        this.$store.dispatch("ui/makeToast", {
          icon: "error",
          title: "Ocurrio un error al generar el excel."
        });
      }
    }
  }
};
</script>

<style lang="scss">
.customLink {
  cursor: pointer;
}
</style>
